var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElFormItem',_vm._g(_vm._b({staticClass:"form-item-with-hint"},'ElFormItem',_vm.$attrs,false),_vm.$listeners),[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),_c('Hint',{attrs:{"message":_vm.hint}})],1),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }